/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const ConversationSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 17 17"
  >
    <path
      fill="currentColor"
      d="M9 1.203a1.052 1.052 0 00-1 0L1.627 4.646a1.086 1.086 0 00-.563.949v.88l6.109 3.711L8.5 9.38l1.328.807 6.11-3.712v-.879a1.086 1.086 0 00-.564-.949L9 1.203zm6.938 6.526l-5.077 3.084 5.076 3.085v-6.17zM15.9 15.13l-7.4-4.498-7.4 4.497c.06.228.194.43.38.573.185.143.412.221.645.221h12.75c.233 0 .46-.078.645-.221.186-.144.32-.345.38-.573v.001zM1.062 13.897l5.077-3.085L1.062 7.73v6.17-.002zM7.5.253a2.104 2.104 0 012 0l6.375 3.443c.34.184.624.457.822.792.198.334.303.717.303 1.107v9.253c0 .57-.224 1.118-.622 1.522-.399.403-.94.63-1.503.63H2.125a2.111 2.111 0 01-1.503-.63A2.166 2.166 0 010 14.848V5.595c0-.39.105-.773.303-1.107.198-.335.482-.608.822-.792L7.5.253z"
    ></path>
  </svg>
);

export const ConversationIcon = props => <Icon component={ConversationSvg} {...props} />;

